export const formatPhoneForAPI = (phone: string, code: string) =>
  `${code !== '1' ? `+${code}` : ''}${phone.replace(/\D/g, '')}`
